import { CIcon } from '~/icons/types'

export const ciMagnifyingGlass: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M10.5 3.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-8 7a8 8 0 1 1 14 5.292l4.854 4.854a.5.5 0 0 1-.708.708l-4.854-4.855a8 8 0 0 1-13.292-6Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'magnifying-glass',
  type: 'thin'
}
